import { Button, Grid, Stack, Text, Title } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';

import { Select } from '@components';
import { useCustomersNamesAndIds } from '@hooks/customer';
import { TransitViewGeneralInfoFormValues } from './validateTransitViewGeneralInfoForm';

interface TransitCustomerSectionProps {
  form: UseFormReturnType<TransitViewGeneralInfoFormValues>;
  editDisabled: boolean;
}

export const TransitCustomerSection: React.FC<TransitCustomerSectionProps> = ({ form, editDisabled }) => {
  const customersNamesAndIds = useCustomersNamesAndIds();

  const selectedCustomerValue = form.values.customer;

  const updateCustomerHandler = (value: string | null) => {
    form.setFieldValue('customer', value);
    form.setTouched({ customer: true });
  };

  const setRefreshCustomerData = () => {
    form.setFieldValue('refreshCustomerData', true);
  };

  return (
    <Stack mb="xl">
      <Title order={5} fw={600}>
        Customer
      </Title>
      <Grid>
        <Grid.Col span={4}>
          <Select
            label="Select customer"
            data={customersNamesAndIds}
            value={selectedCustomerValue}
            onChange={updateCustomerHandler}
            error={form.isTouched('customer') && form.errors.customer !== undefined ? form.errors.customer : null}
            searchable
            maxDropdownHeight={200}
            size="lg"
            disabled={editDisabled}
          />
          {form.values.refreshCustomerData && <Text c="red">You need to save the form in order to apply the changes!</Text>}
        </Grid.Col>
        {!editDisabled && (
          <Grid.Col span={2}>
            <Button type="button" h={50} onClick={setRefreshCustomerData} variant="filled" size="lg">
              Refresh customer data
            </Button>
          </Grid.Col>
        )}
      </Grid>
    </Stack>
  );
};
